import axios from 'axios';

const aiAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_AI_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:5001' : 'https://teach-ai-aq9x.vercel.app'),
  timeout: 120000, // 2 minutes timeout for AI operations (increased from 60s)
  headers: {
    'Content-Type': 'application/json',
  },
});

aiAxiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Add response interceptor for better error handling
aiAxiosInstance.interceptors.response.use(
  (response) => {
    console.log('AI Request successful:', response.config.url);
    return response;
  },
  (error) => {
    console.error('AI Request failed:', {
      url: error.config?.url,
      status: error.response?.status,
      message: error.message,
      code: error.code
    });
    
    // Provide more specific error messages
    if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
      const timeoutError = new Error('AI request timed out. This operation is taking longer than expected. Please try again.');
      timeoutError.name = 'TimeoutError';
      return Promise.reject(timeoutError);
    }
    
    if (!error.response) {
      const networkError = new Error('Unable to connect to AI service. Please check your internet connection.');
      networkError.name = 'NetworkError';
      return Promise.reject(networkError);
    }
    
    return Promise.reject(error);
  }
);

export default aiAxiosInstance; 